const formatCommas = (x: number | string) => {
  return typeof x === "number" || typeof x === "string"
    ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    : "";
};
export default formatCommas;
